import React, { Fragment } from 'react';
import Logs from './Logs';
import { contractType } from 'custom/constants';
import http from 'utils/http';
import { getLocatDate } from 'utils/converter';
import cookies from 'utils/cookies';
import { setDeleteAction } from 'store/actions/deleteAction';
import { setDocAction } from 'store/actions/docAction';
import { connect } from 'react-redux';
import events from 'utils/evemts';
import moment from 'moment';
import { toast } from 'react-toastify';

class LogsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        type: 'DAY',
        airline: null,
        month: moment.utc().endOf('month').format('YYYY-MM-DD'),
        start_date: getLocatDate('YYYY-MM-DD'),
        end_date: getLocatDate('YYYY-MM-DD'),
      },
      airlineId: null,
      airlines: [],
      contracts: [],
      logs: [],
      contract_loading: false,
      log_loading: false,
      contract_Type: 'Cargo Handling',
      filteredData: [],
      contractTypesList: [],
      remark: '',
      anchorEl3: null,
      remarks: '',
      filterLogs: 'All',
      popup: false,
      rows: [],
      allChecked: false,
      contractNames: [],
      updatedLogs: [],
      checkedRows: [],
      popupData: {},
      anchorEl: null,
      noteFields: { note: '', },
      isRemarks: false,
      filteredRows: [],
      newLog: [],
      showMoreNote: {},
    };
    this.eventSource = null;
    this.refROBrn = React.createRef();
  }

  componentDidMount() {
    this.fetchAirlines();
    this.handleEvents();
  }

  componentWillUnmount() {
    this.eventSource.close();
  }

  handleEvents = () => {
    this.eventSource = events('service_log');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (msg.action == 'add_service_log' ) {
        this.setState(prevState => {
          let rows = [...prevState.rows || []];
          let index = rows.findIndex(c => c.date === msg.data.date.split('T')[0]);
          const checkedIndexes = rows
            .map((row, idx) => this.state.checkedRows.includes(row.id) ? idx : -1)
            .filter(idx => idx !== -1);
          rows.map((row, i) => {
            if (checkedIndexes.includes(i)) {
              row.checked = true;
            }
          });
          let apiRow = msg.data;

          const dataFields = (Array.isArray(apiRow.data) && apiRow.data.length)
            ? apiRow.data.map(item => ({
              label: item.label,
              value: item.label?.includes(' | Auto') ? '1' : item.value,
              contractId: item.contractId || null,
              contractrowId: item.contractrowId || null,
              roles: item.roles || null,
              user: item.user || null,
              date: item.date || null,
              isAuto: item.label?.includes(' | Auto') ? true : false
            }))
            : [];

          const mergedRows = {
            id: msg.data.id,
            date:  msg.data.date.split('T')[0],
            isLogPresent: true,
            checked: apiRow.data.every(item => item.label?.includes(' | Auto') ? true : false),
            status: apiRow.status || null,
            data: dataFields,
            notes: apiRow.notes || [],
            log: apiRow.log || [],
            docs: apiRow.docs || [],
            type: apiRow.type || null
          };

          if (index > -1) {
            rows[index] = mergedRows;
          }

          return { rows };
        }, () => {
          this.generateRowsFromStatus();
        });
      }
      if (msg.action == 'update_service_log') {
        this.setState(prevState => {
          const rows = [...prevState.rows || []];
          const index = rows.findIndex(c => c.id == msg.data.id);
          const checkedIndexes = rows
            .map((row, idx) => this.state.checkedRows.includes(row.id) ? idx : -1)
            .filter(idx => idx !== -1);
          rows.map((row, i) => {
            if (checkedIndexes.includes(i)) {
              row.checked = true;
            }
          });
          if (index > -1) {
            const apiRow = msg.data;
            const dataFields = Array.isArray(apiRow.data) && apiRow.data.length
              ? apiRow.data.map(item => ({
                label: item.label,
                value: item.label?.includes(' | Auto') ? '1' : item.value,
                contractId: item.contractId || null,
                contractrowId: item.contractrowId || null,
                roles: item.roles || null,
                user: item.user || null,
                date: item.date || null,
                isAuto: item.label?.includes(' | Auto') ? true : false,
                notes: item.notes || [],
                log: item.log || [],
                docs: item.docs || [],
              }))
              : [];

            const mergedRows = {
              id: msg.data.id,
              date: msg.data.date.split('T')[0],
              isLogPresent: true,
              // checked: msg.data.status === 'Finalized' ? true : false,
              checked: false,
              status: msg.data.status || null,
              data: dataFields,
              notes: rows[index]?.notes || [],
              log: msg.data.log || [],
              docs: msg.data.docs || [],
              type: msg.data.type || null
            };

            rows[index] = mergedRows;
          }
          else if (index === -1 && msg.data.id) {
            let indexRow = rows.findIndex(c => c.date == msg.data.date.split('T')[0]);

            const mergedRows = {
              id: msg.data.id,
              date:  msg.data.date.split('T')[0],
              isLogPresent: true,
              checked: false,
              status: msg.data.status || null,
              data: msg.data.data || [],
              notes: msg.data.notes || [],
              log: msg.data.log || [],
              docs: msg.data.docs || [],
              type: msg.data.type || null
            };
            if (indexRow  > -1) {
              rows[indexRow] = mergedRows;
            }
          }

          return { rows };
        }, () => {
          this.generateRowsFromStatus();
        });
      }
      if(msg.action == 'add_note'){
        let filteredRows = [...this.state.filteredRows || []];
        let index = filteredRows.findIndex(c => c.id == msg.data.service_logId);
        if (index > -1) {
          filteredRows[index].notes.push(msg.data);
          this.setState({ filteredRows });
        }
      }

      if (msg.action == 'add_service_log_doc') {
        let filteredRows = [...this.state.filteredRows || []];
        let index = filteredRows.findIndex(c => msg.data && c.id == msg.data.service_logId);
        if (index > -1) {
          filteredRows[index].docs.push(msg.data);
          this.setState({ filteredRows }, () => {
            this.handleDoc(filteredRows[index]);
          });
        }
      }

      if (msg.action == 'delete_service_log_doc') {
        let filteredRows = [...this.state.filteredRows || []];
        const index = filteredRows.findIndex(c => msg.data && c.id == msg.data.service_logId);
        if (index > -1) {
          const index2 = filteredRows[index].docs.findIndex(cr => msg.data && cr.id == msg.data.id);
          if (index2 > -1) {
            filteredRows[index].docs.splice(index2, 1);
            this.setState({ filteredRows });
          }
        }
      }
    };
  };

  fetchContractTypes = () => {
    http.get(`/check_contract?airline=${this.state.search.airline}&record_on=log&from=${this.state.search.start_date}&to=${this.state.search.end_date}`)
      .then(response => {
        const { data } = response;
        if (data.status === 'success') {
          let contractTypes = [...new Set(data.data.map(item => item.type))];
          this.setState({ contractTypesList: contractTypes, });
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  fetchUser = () => {
    http.get(`/user?id=${cookies.get('user')}`).then(({ data }) => {
      if(data && data.data && data.data.length > 0){
        let cont_item = null;
        let userContractTypes = data.data[0]?.contract_types || [];
        //get first key and value from contractType
        let firstRecord = Object.entries(contractType).find(([ , value]) => userContractTypes.includes(value));
        if (firstRecord) {
          cont_item = firstRecord[1];
        }
        this.setState({ 
          userContractTypes : data.data[0]?.contract_types || [],
          cont_item: cont_item,
          contract_Type: data.data[0]?.contract_types?.length > 0 ? data.data[0]?.contract_types[0] : null
        },()=> this.fetchLogs());
      }
    });
  };

  fetchAirlines = () => {
    http.get(`/airline?active=${true}`)
      .then((response) => {
        // handle success
        this.setState({ 
          airlines: response.data.data,
          search: {
            ...this.state.search,
            airline: this.state.airlineId || response.data.data[0]?.id
          }
        },()=>{
          this.fetchContractTypes();
          this.fetchContracts();
          this.fetchLogs();
          this.fetchUser();
          // this.generateRowsFromFilter();

        });
      });
  };

  fetchContracts = () => {
    let url = '';
    if (this.state.search.type === 'DAY') {
      if (!this.state.search.airline || !this.state.search.start_date || !this.state.search.end_date || !this.state.search.type) return;
      url = `/contract_logs/${this.state.search.airline}?start_date=${this.state.search?.start_date}&end_date=${this.state.search?.end_date}&type=${this.state.search.type}&contract=${this.state.contract_Type}`;
    }
    else if (this.state.search.type === 'MONTH') {
      if (!this.state.search.airline || !this.state.search.month || !this.state.search.type) return;
      url = `/contract_logs/${this.state.search.airline}?date=${this.state.search?.month}&type=${this.state.search.type}&contract=${this.state.contract_Type}`; //dnd
    }
    http.get(url)
      .then((response) => {
        // handle success
        this.setState({
          contracts: response.data.data,
          contract_loading: false
        }, () => {
          this.getContractNames();
        });
      });
  };

  fetchLogs = () => {
    let url = '';
    if (this.state.search.type === 'DAY') {
      if (!this.state.search.airline || !this.state.search.start_date || !this.state.search.end_date || !this.state.search.type) return;
      url = `/service_log/${this.state.search.airline}?start_date=${this.state.search?.start_date}&end_date=${this.state.search?.end_date}&type=${this.state.search.type}&contract=${this.state.contract_Type}`;
    }
    else if (this.state.search.type === 'MONTH') {
      if (!this.state.search.airline || !this.state.search.month || !this.state.search.type) return;
      url = `/service_log/${this.state.search.airline}?date=${this.state.search?.month}&type=${this.state.search.type}&contract=${this.state.contract_Type}`;
    }
    http.get(url)
      .then((response) => {
        this.setState({
          logs: response.data.data,
          log_loading: false
        }, () => {
          this.generateRowsFromFilter();
        });
      })
      .catch((error) => {
        console.error('Error fetching logs:', error);
        this.setState({ log_loading: false });
      });
  };

  onChange = (e) => {
    if (e.target.name == 'remark') {
      this.setState({ remark: e.target.value });
    }
  };

  handleDoc = (row) => {
    this.props.setDoc({
      modal: 'service_log',
      id: row.id,
      data: row.docs
    });
  }; 

  //new code
  onChangeFilter = (e) => {
    this.setState({
      filterLogs: e.target.value,
      filteredRows: [],
    }, () => {
      this.generateRowsFromStatus();
    });
  };


  onChangeSearch = (e) => {
    let search = { ...this.state.search };
    search[e.target.name] = e.target.value;
    if (e.target.name === 'month') {
      search['month'] = moment(e.target.value).endOf('month').format('YYYY-MM-DD');
    }
    if (e.target.name === 'start_date' && e.target.value) {
      search['end_date'] = moment(e.target.value).format('YYYY-MM-DD');
    }
    this.setState({
      search,
      // data: [],
      // checked: [],
      // remark: ''
    }, () => {
      this.fetchContractTypes();
      this.fetchContracts();
      this.fetchLogs();
      // this.generateRowsFromFilter();
    });
  };

  handleClick = (anchorEl) => {
    this.setState({ 
      anchorEl3: anchorEl,
      remarks: '',
    });
  };

  handleClose = () => {
    this.setState({
      anchorEl3: null,
      remarks: '',
    });
  };

  handleContractType = (e) => {
    let cont_item = contractType[e.target.value];
    this.setState({ 
      contract_Type: e.target.value,
      cont_item: cont_item,
    },()=> {
      this.fetchContracts();
      this.fetchLogs();
    });
  };

  getContractNames = () => {
    let contractNames = [];
    let contracts = this.state.contracts;
    contracts.forEach((contract) => {
      if(contract.contractrows && contract.contractrows.length > 0) {
        contract.contractrows.forEach((contractrow) => {
          contractNames.push({
            contractId: contractrow.contractId,
            contractRowId: contractrow.id,
            name: `${contractrow.description} ${contractrow.applied_on}`,
            description: contractrow.description,
            appliedOn: contractrow.applied_on,
            recordOn: contractrow.record_on,
          });
        });
      }
    });
    this.setState({ contractNames }, () => {
      //need the callback to ensure state is updated before logging
      this.generateRowsFromFilter();
    });
  };

  formatDate = (date) => moment(date).format('YYYY-MM-DD');
  // new Date(date)
  //   .toLocaleDateString('en-GB', {
  //     day: '2-digit',
  //     month: 'short',
  //     year: '2-digit',
  //   })
  //   .replace(/ /g, '')
  //   .toUpperCase();

  formatMonth = (date) => moment(date).endOf('month').format('YYYY-MM-DD');

  // Step 1: Generate date list
  generateDateList = (start, end) => {
    const dates = [];
    // let curr = new Date(start);
    // const endDate = new Date(end);

    // while (curr <= endDate) {
    //   dates.push(this.formatDate(curr));
    //   curr.setDate(curr.getDate() + 1);
    // }
    let curr = moment.utc(start);
    const endDate = moment.utc(end);

    while (curr.isSameOrBefore(endDate, 'day')) {
      dates.push(curr.format('YYYY-MM-DD'));
      curr.add(1, 'day');
    }

    console.log('start,end', start, end);
    console.log('dates_______________________', dates);
    return dates;
  };

  generateRowsFromFilter = () => {
    const { start_date, end_date, month, type } = this.state.search;
    let contractNameList = [];
    let dataFields = [];
    let logsData = [...this.state.logs || []];
    let isAllAuto = false;
    if(this.state.contractNames.every(item => item?.name?.includes(' | Auto'))) {
      isAllAuto = true;
    }
    const dateList = type === 'DAY' ? this.generateDateList(start_date, end_date) : [this.formatMonth(month)];
    const mergedRows = dateList.map((date, index) => {
      const apiRow = logsData.find((row) => this.formatDate(row.date) === date);
      if (isAllAuto ) {
        contractNameList = (Array.isArray(this.state.contractNames) && this.state.contractNames.length > 0) ?
          this.state.contractNames?.map(item => {
            return {
              label: item.name,
              value: null,
              contractId: item.contractId || null,
              contractrowId: item.contractRowId || null,  
              roles: item.roles || null,
              user: item.user || null,
              isAuto: true,
              date: item.date || null
            };
          }) : [];
        return {
          id: apiRow ? apiRow.id : index + 1,
          date,
          isLogPresent: true,
          checked: false,
          data: contractNameList,
          notes: [],
          status: apiRow ? apiRow.status : null,
          log: [],
          docs: [],
          type: this.state.search.type,
        };
      }
      else {
        if (!apiRow || !apiRow.data || apiRow.data.length === 0) {
          contractNameList = (Array.isArray(this.state.contractNames) && this.state.contractNames.length > 0) ?
            this.state.contractNames?.map(item => {
              return {
                label: item.name,
                value: null,
                // value: item.name?.includes(' | Auto') ? '1' : '',// dnd
                contractId: item.contractId || null,
                contractrowId: item.contractRowId || null,
                roles: item.roles || null,
                user: item.user || null,
                isAuto: false,
                date: item.date || null
              };
            }) : [];
          return {
            id: index + 1,
            date,
            isLogPresent: this.state.contractNames.length > 0 && this.state.contractNames?.every(item => item.name?.includes(' | Auto') ? true : false),
            checked: false,
            data: contractNameList,
            notes: [],
            status: null,
            log: [],
            docs: [],
            type: this.state.search.type,
          };
        }
        else {
          dataFields = (Array.isArray(apiRow.data) && apiRow.data.length)
            ? apiRow.data.map(item => {
              return {
                label: item.label,
                value: item.label?.includes(' | Auto') ? null : item.value,
                contractId: item.contractId || null,
                contractrowId: item.contractrowId || null,
                roles: item.roles || null,
                user: item.user || null,
                isAuto: item.label?.includes(' | Auto') ? true : false,
                date: item.date || null
              };
            })
            : [];
          return {
            id: apiRow.id,
            date,
            isLogPresent: true,
            checked: apiRow.checked,
            status: apiRow.status || null,
            data: dataFields,
            notes: apiRow.notes || '',
            log: apiRow.log || [],
            docs: apiRow.docs || [],
            type: apiRow.type || null
          };
        }
      }
      
    });
    this.setState({
      rows: mergedRows,
      allChecked: false,
      filteredRows: [],
    }, () =>{
      this.generateRowsFromStatus();
    });
  };

  handleBulkCheck = (event) => {
    const isChecked = event.target.checked;
    const updatedfilteredRows = this.state.filteredRows.map((row) => ({
      ...row,
      checked: isChecked,
    }));

    if(this.state.contractNames.every(item => item?.name?.includes(' | Auto')) && isChecked) {
      updatedfilteredRows.forEach(row => {
        if (row.data.every(item => item?.label?.includes(' | Auto')) && row.status !== 'Submitted') {
          row.data.forEach(item => {
            this.handleLogs(row, item.label, null);
          });
        }
      });
    }

    this.setState({
      filteredRows: updatedfilteredRows,
      allChecked: isChecked,
      checkedRows: this.state.filterLogs != 'Finalized' ? 
        updatedfilteredRows.filter((row) => row.checked && (row.status !== 'Finalized' || row.status !== 'Pending' || row.status !== 'Approved')).map((row) => row.id) : 
        updatedfilteredRows.filter((row) => row.checked && (row.status === 'Finalized' || row.status === 'Pending' || row.status === 'Approved')).map((row) => row.id)
    });
  };

  handleRowCheck = (row) => (event) => {
    const updatedfilteredRows = this.state.filteredRows.map((r) =>
      r.id === row.id ? {
        ...r,
        checked: event.target.checked
      } : r
    );
    const allChecked = updatedfilteredRows.every((r) => r.checked);
    this.setState({
      filteredRows: updatedfilteredRows,
      allChecked,
      checkedRows: updatedfilteredRows.filter((row) => row.checked).map((row) => row.id) 
    }, ()=> {
      if(row.data.every(item => item?.label?.includes(' | Auto')) && row.status !== 'Submitted') {
        row.data.forEach(item => {
          this.handleLogs(row, item.label, null);
        });
      }
    });
  };

  handleInputChange = (row, field, value) => {
    const updatedRows = this.state.filteredRows.map((r) =>
      r.id === row.id ? {
        ...r,
        data: r.data.map((item) => {
          return {
            ...item,
            value: item.label === field ? value : item.value,
            // date: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
          };
        }),
      } : r
    );

    this.setState({ filteredRows: updatedRows, }, () => {
      this.handleLogs(row, field, value);
    });
  };

  handleLogs = (row, field, value) => {
    let filteredRows = [...this.state.filteredRows || []];
    let newLog = [];
    let user = {
      first_name: cookies.get('name').split(' ')[0],
      last_name: cookies.get('name').split(' ')[1],
      role: cookies.get('role'),
    };
    if(row.isLogPresent) {
      filteredRows = filteredRows.map((log) => {
        return log.id === row.id ? {
          ...log,
          data: log.data?.map((item) =>
            item.label === field ? {
              ...item,
              value: value,
              date: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
              user: user,
            } : item
          ),
        } : log;
      });
    } 
    else {

      let existingIndex = row.data.findIndex(item => item.label === field);
      if (existingIndex > -1) {
        row.data[existingIndex].value = value; 
        row.data[existingIndex].user = user;
        row.data[existingIndex].date = moment().utc().format('YYYY-MM-DD HH:mm:ss');
      }
      newLog = row.data;
    }
    this.setState({
      filteredRows: filteredRows,
      newLog,
    }, () => {
      if(row.data.every(item => item?.label?.includes(' | Auto'))) {
        this.handleBlur(row);
      }
    });
  };
 
  handleBlur = (row) => {
    const { filteredRows, newLog } = this.state;
    const originalRow = [...this.state.rows || []];
    const rowId = row?.id;
    let index = filteredRows.findIndex(c => c.id === rowId);
    let data = {};
    if (row.isLogPresent) {
      if(row.data.every(item => item?.label?.includes(' | Auto'))) {
        data = {
          date: this.state.search.type === 'MONTH' ? moment(row.date).endOf('month').format('YYYY-MM-DD') : new Date(row.date).toISOString(),
          airlineId: this.state.search.airline,
          data: row.data,
          type: this.state.search.type,
          contract: this.state.contract_Type,
        };
      }
      else { 
        let filteredData = filteredRows[index]?.data?.filter(c => this.state.contractNames.some(item => item.name === c.label));
        data = {
          date: this.state.search.type === 'MONTH' ? moment(filteredRows[0]?.date).endOf('month').format('YYYY-MM-DD') : new Date(filteredRows[0]?.date).toISOString(),
          airlineId: this.state.search.airline,
          data: filteredData,
          type: filteredRows[0]?.type,
          contract: this.state.contract_Type,
        };  
      }
    } 
    else {
      data = {
        date: this.state.search.type === 'MONTH' ? moment(row.date).endOf('month').format('YYYY-MM-DD') : new Date(row.date).toISOString(),
        airlineId: this.state.search.airline,
        data: newLog,
        type: this.state.search.type,
        contract: this.state.contract_Type,
      };
    }

    if(rowId) {
      let id = ' ';
      if (row.isLogPresent) {
        if(row.data.every(item => item?.label?.includes(' | Auto'))) {
          id = ' ';
        }
        else id = rowId;
      }
      if(row?.data === originalRow[index]?.data) {
        return;
      }
      else {
        http.post(`/service_log/${id}`, data).then((res) => {
          if (res.data.status === 'success') {
            if (row.data.every(item => item?.label?.includes(' | Auto'))) {
              this.setState(prevState => {
                let index = prevState.filteredRows.findIndex(c => c.date === row.date);
                const updatedFilteredRows = prevState.filteredRows.map((r, idx) =>
                  idx === index
                    ? {
                      ...r,
                      checked: res.data.data.id ? true : undefined 
                    }
                    : r
                );
                return {
                  filteredRows: updatedFilteredRows,
                  checkedRows: [...prevState.checkedRows, res.data.data.id],
                };
              });
            }
          }})
          .catch((error) => {
            console.error('Error saving log:', error);
            toast.error('Error saving log. Please try again.');
          });
      }
    }
  };

  onSubmitLogs = ( statusType = null ) => {  
    let status = statusType || 'Submitted';
    if (statusType == null) {
      const selectedRows = this.state.filteredRows.filter(row => this.state.checkedRows.includes(row.id));
      const hasEmptyInput = selectedRows.some(row =>
        row.data?.some(data => data.value === '' || data.value === null)
      );  
      // Only show buttons if there are checked rows
      if (this.state.checkedRows.length === 0) return null;
      if (hasEmptyInput) {
        status = 'Submitted';
        this.setState({ popup: 'Submitted' });
        return;
      }
      else {
        this.setState({ popup: 'Finalized' });
        return null;
      }
    }
    http.put('/service_log', {
      ids: this.state.checkedRows,
      remark: this.state.remark || '',
      status: status
    }).then(() => {
      if (status === 'Submitted') {
        this.setState((prev) => ({
          filteredRows: [
            ...prev.filteredRows.map(row => ({
              ...row,
              checked: false,
            })),
          ],
        }));
      }
      this.setState({
        checkedRows: [],
        remark: '',
        popup: false,
        anchorEl: null,
        isRemarks: false,
        popupData: null,
      });
    });
    // .catch((error) => {
    //   console.error('Error submitting logs:', error);
    // });
    
  };

  inputValidation = (status) => {
    const { checkedRows, filteredRows } = this.state;
    let allFieldsFilled = true;
    if (checkedRows.length === 0) {
      toast.warning('No Records are selected.');
      return false; 
    }
    if (checkedRows.length > 0 && status === 'Submitted') {
      allFieldsFilled =  true;
    }
    else {
      this.state.contractNames.forEach(item => {
        filteredRows.forEach((row) => {
          row.data.forEach((dataItem) => {
            if (row.checked && dataItem.label.includes(' | Auto')) {
              toast.warning(`Please fill all the fields for ${row.date} - ${item.name}`);
              allFieldsFilled = true;
            }
            else if (row.checked && (dataItem.value === '' || dataItem.value === null || dataItem.value === undefined)) {
              toast.warning(`Please fill all the fields for ${row.date} - ${item.name}`);
              allFieldsFilled = false;
            }
          });
        });
      });
    }
    return allFieldsFilled;
  };

  handleOpenPopup = (popup, anchorEl=null, data={}) => {
    if (popup === 'notes') {
      if (Array.isArray(data.row.notes) && data.row.notes.length > 0) {
        // Filter notes where cont_rowId matches any contractRowId in contractNames
        data = {
          ...data,
          filteredNotes: data.row.notes.filter(note => data.contractRowId === note.cont_rowId),
        };
      }
      
      if (data.type === 'remarks') {
        data = {
          ...data,
          filteredNotes: data.row.log 
        };
      }
    }
    this.setState({
      popup,
      anchorEl,
      popupData: data,
      isRemarks: data.type === 'remarks' ? true : false,
    });
  };

  handleClosePopup = () => {
    this.setState({
      popup: false,
      anchorEl: null,
      isRemarks: false,
      popupData: null,
      noteFields: { note: '', },
      showMoreNote: {},
    });
  };

  addNote = () => {
    if (this.state.noteFields.note.trim() === '') {
      return;
    }
    http.post(`/note/log/${this.state?.popupData?.row?.id}/${this.state.popupData?.contractRowId}`, { note: this.state.noteFields.note, }).then(() => {
      this.setState({
        noteFields: { note: '', }, 
        popup: false,
        anchorEl: null,
      });
    });
  };

  handleNotes = (e) => {
    this.setState({
      noteFields: {
        ...this.state.noteFields,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleReadMore = (index) => {
    this.setState((prevState) => ({
      showMoreNote: {
        ...prevState.showMoreNote,
        [index]: !prevState.showMoreNote[index]
      },
    }));
  };

  generateRowsFromStatus = () => {
    let filteredRows = [...this.state.rows || []];

    if(this.state.filterLogs === 'All'){
      filteredRows = filteredRows.filter(item => !item.status || item.status === 'Reopen' || item.status === 'Submitted' || item.status === 'Finalized' || item.status === null || item.status);
    }

    if(this.state.filterLogs === 'Submitted'){
      filteredRows = filteredRows.filter(item => item.status === 'Submitted');
    }
    if(this.state.filterLogs === 'Pending'){
      filteredRows = filteredRows.filter(item => !item.status || item.status === 'Reopen' || item.status === null
      );
    }
    if (this.state.filterLogs === 'Finalized') {
      filteredRows = filteredRows.filter(item => item.status === 'Finalized' || item.status === 'Approved' || item.status === 'Pending');
      // Set checked: false only for rows that are initially loaded, but allow toggling afterwards
      filteredRows = filteredRows.map((row) => ({
        ...row,
        checked: row.checked ? undefined : row.checked,
        
      }));
    }
    this.setState({ filteredRows: filteredRows, });
  };

  setRemark = (value) => {
    this.setState({ remarks: value });
  };

  render() {
    return (
      <>
        <Logs
          search={this.state.search}
          airlines={this.state.airlines}
          onChangeSearch={this.onChangeSearch}
          onChangeFilter={this.onChangeFilter}
          value={this.state.value}
          refROBrn={this.refROBrn}
          handleClick={this.handleClick}
          contract_Type={this.state.contract_Type}
          handleContractType={this.handleContractType}
          airlineId={this.state.airlineId}
          onChange={this.onChange}
          remark={this.state.remark}
          onSubmit={this.onSubmit}
          contractNames={this.state.contractNames}
          rows={this.state.rows}
          handleBulkCheck={this.handleBulkCheck}
          handleRowCheck={this.handleRowCheck}
          handleInputChange={this.handleInputChange}
          allChecked={this.state.allChecked}
          handleBlur={this.handleBlur}
          onSubmitLogs={this.onSubmitLogs}
          checkedRows={this.state.checkedRows}
          popup={this.state.popup}
          anchorEl={this.state.anchorEl}
          handleOpenPopup={this.handleOpenPopup}
          handleClosePopup={this.handleClosePopup}
          popupData={this.state.popupData}
          noteFields={this.state.noteFields}
          handleNotes={this.handleNotes}
          addNote={this.addNote}
          handleReadMore={this.handleReadMore}
          showMoreNote={this.state.showMoreNote}
          isRemarks={this.state.isRemarks}
          handleDoc={this.handleDoc}
          filteredRows={this.state.filteredRows}
          filterLogs={this.state.filterLogs}
          setRemark={this.setRemark}
          remarks={this.state.remarks}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    doc: { ...state.doc, },
    stations: state.stations,

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setDelete: (data) => dispatch(setDeleteAction(data)),
    setDoc: (data) => dispatch(setDocAction(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogsContainer);
